import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import AcceptXrayManual from 'pages/AcceptXrayManual'
import Storage from 'storage/auth'

/**
 * Renders the x-ray module routes only after the professional accepted the
 * x-ray manual; otherwise shows the acceptance screen in their place. Must be
 * nested under the `cxray_analysis` permission check, which already keeps
 * establishments without the module out.
 */
const XrayManualGate = () => {
  const [accepted, setAccepted] = useState(
    () => Storage.user.get()?.xray_manual_accepted === true
  )

  if (!accepted) {
    return <AcceptXrayManual onAccepted={() => setAccepted(true)} />
  }

  return <Outlet />
}

export default XrayManualGate
